import type { DocMigration } from "../docMigration";

const migration: DocMigration = {
  id: "20260225_add_rear_porch_area",
  description: "Backfill REAR_PORCH_AREA in area report settings and floorAreasRearPorch in view filters",
  apply(json: any) {
    for (const setting of Object.values(json.settings ?? {})) {
      const planSettings = setting as { type?: string; areaReportSettings?: Record<string, any> };
      if (planSettings.type !== "PLAN_SETTINGS") {
        continue;
      }
      if (planSettings.areaReportSettings === undefined) {
        continue;
      }
      if (
        planSettings.areaReportSettings["REAR_PORCH_AREA"] === undefined &&
        planSettings.areaReportSettings["COVERED_PATIO_AREA"] !== undefined
      ) {
        planSettings.areaReportSettings["REAR_PORCH_AREA"] = {
          ...planSettings.areaReportSettings["COVERED_PATIO_AREA"],
          reportedName: "REAR PORCH AREA",
        };
      }
    }

    for (const planView of Object.values(json.planViews ?? {})) {
      const view = planView as { viewFilter?: Record<string, any> };
      if (view.viewFilter !== undefined && view.viewFilter.floorAreasRearPorch === undefined) {
        view.viewFilter.floorAreasRearPorch = view.viewFilter.floorAreasCoveredPatio;
      }
    }

    return json;
  },
};

export default migration;
